import { Subscription } from '@innovyze/shared-utils';

export const isUserFullAccess = (entitlements: string[]) =>
	entitlements.some(
		entitlement =>
			entitlement === Subscription.ASSET_FULL_ACCESS ||
			entitlement === Subscription.I360AFA,
	);
